/**
 * Checks if value is a DOM element.
 *
 * Uses W3 DOM2 API. Returns false in Node.js environments.
 *
 * @param element - Value to check
 * @returns True if DOM Element or HTMLDocument
 */
export const is_element = element => {
  try {
    //Using W3 DOM2 (works for FF, Opera and Chrome)
    return element instanceof Element || element instanceof HTMLDocument
  } catch (e) {
    // nodejs can't do that
    return false
  }
}
